import firebase from 'firebase';

// Initialize Firebase
var config = {
    apiKey: "AIzaSyAqFrmkfm3iSTc_sOCxqg-dcEwwcaX3xCo",
    authDomain: "asmr-sounds.firebaseapp.com",
    databaseURL: "https://asmr-sounds.firebaseio.com",
    projectId: "asmr-sounds",
    storageBucket: "asmr-sounds.appspot.com",
    messagingSenderId: "87366520937"
};
firebase.initializeApp(config);

export const provider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();
export default firebase;


// WEBPACK FOOTER //
// ./src/firebase.js